// Dev-only: rewrite video src URLs to a local range-request server (port 8082)
// so the imported Funnelish MP4s play under Shopify CLI's dev proxy.
document.addEventListener('DOMContentLoaded', function () {
  function rewriteVideos() {
    var host = window.location.hostname;
    var isDev =
      host === 'localhost' ||
      host === '127.0.0.1' ||
      host.indexOf('ngrok') !== -1 ||
      host.indexOf('shopifypreview.com') !== -1 ||
      host.indexOf('preview') !== -1;
    if (!isDev) return;

    var videos = document.querySelectorAll('video');
    videos.forEach(function (video) {
      var src = video.getAttribute('src') || video.getAttribute('data-src') || '';
      if (src && src.indexOf('fnl_') !== -1 && src.indexOf('.mp4') !== -1) {
        var filename = src.split('/').pop().split('?')[0];
        var newSrc = 'http://localhost:8082/' + filename;
        video.setAttribute('src', newSrc);
        video.setAttribute('data-src', newSrc);
        video.load();
      }
      var sources = video.querySelectorAll('source');
      sources.forEach(function (source) {
        var srcAttr = source.getAttribute('src') || source.getAttribute('data-src') || '';
        if (srcAttr && srcAttr.indexOf('fnl_') !== -1 && srcAttr.indexOf('.mp4') !== -1) {
          var filename = srcAttr.split('/').pop().split('?')[0];
          var newSrc = 'http://localhost:8082/' + filename;
          source.setAttribute('src', newSrc);
          source.setAttribute('data-src', newSrc);
        }
      });
      if (sources.length > 0) video.load();
    });
  }

  rewriteVideos();
  setTimeout(rewriteVideos, 500);
  setTimeout(rewriteVideos, 1500);
  setTimeout(rewriteVideos, 3000);
});
